import React, { Component } from 'react'
import { industryList, recruiterRegister } from '../../action/auth';
import Form from '../../old_Components/Register/Register'
import constant from '../../constant';
import Swal from 'sweetalert2';
export default class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            industryType: undefined,

        }
    }
    componentDidMount() {
        document.title = constant.title.Register

        industryList().then(res => {
            if (res.status) {
                this.setState({ industryType: res.result.list })
            }
        })
    }
    onSubmit = (model) => {
        recruiterRegister(model).then(res => {
            if (res.status) {
                Swal.fire({
                    icon: 'success',
                    text: res.messageCode,
                    timer: 1500,
                    showCancelButton: false,
                    showConfirmButton: false
                })
                window.location.href = constant.component.package.url
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: res.error,
                    timer: 1500,
                    showCancelButton: false,
                    showConfirmButton: false
                })
            }
        })
    }

    render() {
        const { industryType } = this.state;
        return (
            <React.Fragment>
                <Form
                    onSubmit={this.onSubmit}
                    industryType={industryType}
                />
            </React.Fragment>
        )
    }
}
